;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.bpu.list')
    .controller('BpuListController', BpuListController)

  BpuListController.$inject = [
    // Angular
    // Libs
    // Managers
    'BpuManager',
    // Services
    'FilterSidebarService', 'ColumnService', 'SelectionService', 'FilterService', 'UtilService', 'PreferencesService',
    // Const
    // Resolved
    'pagination', 'customFields'
  ]
  function BpuListController (
    // Angular
    // Libs
    // Managers
    BpuManager,
    // Services
    FilterSidebarService, ColumnService, SelectionService, FilterService, UtilService, PreferencesService,
    // Const
    // Resolved
    pagination, customFields
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        bpus: [],
        archive: [
          { label: 'Non-archivées', value: false, _id: 'archived' },
          { label: 'Archivées', value: true, _id: 'archived' },
          { label: 'Toutes', value: 'both', _id: 'archived' }
        ],
        loading: false,
        pagination: pagination,
        customFields: customFields,
        sideBar: FilterSidebarService,
        selection: SelectionService.getSelection(),
        ColumnService: ColumnService,
        // Public Method
        addCriteria: addCriteria,
        clearSearch: clearSearch,
        getList: getList,
        isVisible: isVisible,
        saveColumns: saveColumns,
        dropColumn: dropColumn,
        resetColumns: resetColumns,
        sort: sort,
        groupFind: FilterService.groupFind,
        searchClients: searchClients,
        searchBpuLabel: searchBpuLabel
      })

      init()
    }

    function init () {
      self.sideBar.init()
      self.ColumnService.init()
      PreferencesService.getPrefsFor('general').then((prefs) => {
        self.prefs = prefs
        self.columns = UtilService.updateColumnList(ColumnService.getColumns('bpu'), self.customFields, ColumnService.getDefaultColumns('bpu'))
        self.sideBarColumns = UtilService.updateColumnList(ColumnService.getColumns('bpu'), self.customFields, ColumnService.getDefaultColumns('bpu'))
        getList()
      })
    }

    function dropColumn (source, target) {
      var newIndex = _.findIndex(self.columns, { id: target })
      var oldIndex = _.findIndex(self.columns, { id: source })
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0])
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('bpu')
      })
    }

    function resetColumns () {
      self.prefs.settings.bpuList.columns = UtilService.updateColumnList(ColumnService.getDefaultColumns('bpu'), self.customFields, ColumnService.getDefaultColumns('bpu'))
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('bpu')
        self.sideBarColumns = ColumnService.getColumns('bpu')
      })
    }

    function saveColumns (changedCol) {
      let index = self.prefs.settings.bpuList.columns.findIndex(element => element.id === changedCol.id)
      self.prefs.settings.bpuList.columns[index].visible = changedCol.visible
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('bpu')
      })
    }

    function getList () {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true)
      self.pagination.save()
      self.loading = true

      self.pagination.orderBy = self.pagination.orderBy || '-createdAt'

      var hasArchived = self.pagination.search && FilterService.hasArchivedCriteria(self.pagination.search)
      if (!hasArchived) {
        addCriteria('isArchived', { _id: 'archived', value: 'false' })
        return
      }

      var q = {
        populate: JSON.stringify([
          {
            path: 'client',
            select: '__t type number label'
          }
        ]),
        archived: 'both'
      }

      var query = BpuManager
        .query(q)
        .paginate(self.pagination.toQueryOptions())

      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search))
      }

      var promise = BpuManager.post(query, { ignoreArchived: true })
      promise.then(function (data) {
        self.pagination.totalElements = data.meta.total
        self.pagination.save()
        self.bpus = data.data
        self.loading = false

        // Reset the pagination if we try to load page without results
        if (parseInt(data.meta.total) !== 0 && !data.data.length) {
          self.pagination.currentPage = 0
          getList()
        }
      })
    }

    function addCriteria (key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation)
        getList()
      }
    }

    function clearSearch () {
      self.pagination.search = {}
      getList()
    }

    function isVisible (columnId) {
      if (!self.columns) {
        return
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible
        }
      }
      return false
    }

    function sort (name) {
      this.reverse = (self.pagination.orderBy === name) ? !this.reverse : false
      self.pagination.orderBy = name
      self.pagination.reverse = this.reverse
      getList()
    }

    function searchClients (search) {
      if (search) {
        FilterService.searchClients(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data
        })
      }
    }

    function searchBpuLabel (search) {
      FilterService.searchBpuLabel(search).then(function (result) {
        self.labels = result
      })
    }
  }
})(window.angular, window._)
